module.exports = __webpack_public_path__ + "img/zjbank.9a6cc8e4.png";